module.exports = __webpack_public_path__ + "img/choice_port2.8719778a.png";